<div class="tema">
  <label>
    <input type="checkbox"
           [ngModel]="checkbox"
           (change)="onChangeTheme($event)">Tema chiaro
  </label>
</div>
<div class="errorBox"   [ngClass]="{'showError':error}">
  <div class="errorMsg"  *ngIf="error">
    <h2>{{labels?.messaggi?.attenzione}}</h2>
    <div class="msgInfo">
      <p>{{error}}</p>
    </div>
  </div>
</div>
<div class="content" role="main" *ngIf="dataAyuppie && dataAyuppie.name">


  <app-info-modal [labels]="labels"
                  [visible]="modalOut"
                  [title]="modal_title"
                  [description]="modal_desc"
                  [finishes]="modal_solutions"
                  [imgs]="modal_imgs"
                  (onCloseMe)="onHideModal()"></app-info-modal>
  <!--  <div [innerHTML]="dataAyuppie.name"></div>-->

  <!--  <app-hero [data_hero]="data.hero" [data_aiuppie]="dataAyuppie"></app-hero>-->
  <app-hero-black [labels]="labels"
                  [data_aiuppie]="dataAyuppie"
                  [buyer]="dataAyuppie.buyer" [info]="dataAyuppie.info" [user]="dataAyuppie.user"></app-hero-black>

  <!--  <app-video-animation [data_general]="data.general"></app-video-animation>-->


<!-- slider per lo zoom per tutti i pdf -->
<!--    <div>-->
<!--        <label>Zoom: {{ zoomLvl }}</label>-->
<!--        <input-->
<!--                type="range"-->
<!--                min="0.5"-->
<!--                max="3"-->
<!--                step="0.1"-->
<!--                [ngModel]="zoomLvl"-->
<!--                (ngModelChange)="zoomLvl = +$event">-->
<!--    </div>-->

    <div class="pdf-wrapper">
        <pdf-viewer
                *ngFor="let pdfUrl of attachments"
                [src]="pdfUrl.url"
                [render-text]="true"
                [original-size]="false"
                [autoresize]="true"
                [show-all]="true"
                [zoom]="zoomLvl || 1"
                class="pdf-viewer">
        </pdf-viewer>
    </div>

  <!--  <a id="moodboard" href="#"></a>-->
  <app-style-pictures-moodboard [labels]="labels"
                                (onShowStylePic)="onShowGalleryModal($event)"
                                [section_id]="'imgsection_start'"
                                [solutions]="dataAyuppie.solutions"
                                [stylePictures]="dataAyuppie.stylePictures"

    >
  <!-- 👆🏻 test: [stylePictures]="dataAyuppie.stylePictures.concat(dataAyuppie.stylePictures.concat(dataAyuppie.stylePictures))"  -->
  </app-style-pictures-moodboard>



  <div *ngFor="let scenario of scenarios">

    <app-sections-left-right [labels]="labels"
                             [sections]="scenario.sections"
                             [stylePictures]="dataAyuppie.stylePictures"
                             (onScopriDiPiu)="onShowSectionsModal($event)"
                             (onShowAllPics)="onShowGalleryModal($event)"
    ></app-sections-left-right>


    <app-text-glow-grid [labels]="labels"
                        [is_end]="false"
                        [totaleZone]="dataAyuppie.totaleZone"
                        [data_scenarios]="scenario">
    </app-text-glow-grid>
  </div>
    <br/>
  <app-footer [labels]="labels" [data_aiuppie]="dataAyuppie"></app-footer>
</div>
